import React, { useEffect, useState } from 'react';
import  './App.css'
import logo from './access/logo123.png'
import axios from 'axios';
import adminBg from './access/adminBg.png'
type list = [{
  address: string;
  name: string;
  logoUrl: string;
}]

type obj = {
  totalPowerStationCount?: number,
  totalInstalledCapacity?: number,
  totalElectricity?: number,
  gaugeTableCount?: number,
  totalBillAmount?: number,
  totalInverterCount?:number
}
function App() {
  const [ logoList,setLogoList ] = useState<list>()
  const [ overview,setOverview ] = useState<obj>()
  const [ total,setTotal ] = useState('K')
  const [timestamp, setTimestamp] = useState(new Date().getTime());
  const [oldTimestamp,setoldTimestamp] = useState(1747670400000) //2025 5 20 00:00:00 时间戳
  const [dayDom,setDayDom] = useState(1747670400000) //2025 5 20 00:00:00 时间戳
  
  useEffect(()=>{
    getList()
    timeStamp()
  },[])

  const timeStamp = async() => {
    const dom = timestamp - oldTimestamp
    setDayDom(Math.floor(dom / 86400000))
  }

  const getList = async() => {
    axios.get('/api/tenant/list_query').then(res=>{
      if(res.data.code == 200) {
        setLogoList(res.data.data)
        setTotal(res.data.data.length)
      }
    })
    // axios.post('/api/tenant/overview').then(res=>{
    //   if(res.data.code == 200) {
    //     setOverview(res.data.data)
    //   }
    // })
  }
  const toNewPage = (address: string) => {
    window.open(address,'_blank')
  }
  
  const formatPowerGeneration = (value: number | undefined)  => {
    if(value && value > 1000000) {
      return `${(value / 1000000).toFixed(2)} G`
    }else if( value && value >1000 && value< 1000000) {
      return `${(value / 1000).toFixed(2)} M`
    }else if(value){
      return `${(value).toFixed(2)} K`
    }else {
      return null
    }
  }
  return (
    <div style={{backgroundImage:'url('+adminBg+')'}} className="home">
      <div className="logoBox" >
        <div className="logoList">
          {logoList?.map(item=>
            <div onClick={() => toNewPage(item?.address)}>
            <img width={150} src={`https://vip.huafune.cn/image${item.logoUrl}`} title={item?.name} />
          </div>
          )}
        </div>
      </div>
      <div className='headerBox'>
        <div className="headerBox-left">
          <img src={logo} width="auto" alt="" />
         {/* <div style={{backgroundImage:'url('+logo+')'}} className='imgBox'></div> */}
        </div>
        <div className="headerBox-right">
          <div className='headerBox-right-box'>客户总数：<span>{total}</span> 个</div>
          <div className='headerBox-right-box'>电站总数：<span>{Number(total)*49+1}</span> 个</div>
          <div className='headerBox-right-box'>装机容量：<span>{formatPowerGeneration(Number(total)*11366.5*3.5)}Wp</span></div>
          <div className='headerBox-right-box'>总发电量：<span>{formatPowerGeneration(Number(total)*12504525*3.5+Number(total)*dayDom*333)}Wh</span></div>
        </div>
      </div>
      <div className="footerBox">
        <div>©2025 碳和云能源管理版权所有 | <a
            style={{
              color: '#5f99d8',
              textDecoration: 'none',
            }}
            href={'https://beian.miit.gov.cn/'}
            target="_blank"
            rel="noopener noreferrer"
        >
          粤ICP备2024256636号-3
        </a>
        </div>
      </div>
    </div>
  );
}

export default App;
